"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Buffer = void 0;
// Browser polyfills for Solana libraries
var buffer_1 = require("buffer");
Object.defineProperty(exports, "Buffer", { enumerable: true, get: function () { return buffer_1.Buffer; } });
// Polyfill Buffer globally
if (typeof window !== 'undefined') {
    window.Buffer = window.Buffer || buffer_1.Buffer;
    window.global = window.global || window;
    window.process = window.process || {
        env: {},
        version: '',
        platform: 'browser'
    };
}
// Polyfill for Node.js globals
if (typeof global === 'undefined') {
    globalThis.global = globalThis;
}
